import type { Dict } from '../i18n';

const dict: Dict = {
  en: {
    heading: 'Page not found',
    message: "The page you're looking for doesn't exist.",
    goHome: 'Go home',
  },
  es: {
    heading: 'Página no encontrada',
    message: 'La página que buscas no existe.',
    goHome: 'Ir al inicio',
  },
  de: {
    heading: 'Seite nicht gefunden',
    message: 'Die gesuchte Seite existiert nicht.',
    goHome: 'Zur Startseite',
  },
};

export default dict;
